<template>
<div id="secure">

    <TopMenu />
    <section class="main-content columns is-fullheight">
        <div class="container column is-12">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card">
                    <div class="card-header">
                        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                            <ul>
                                <li><a v-on:click="goGroupDashboard()">Group Dashboard</a></li>
                                <li class="is-active"><a href="#" aria-current="page">{{ groupName }}</a></li>
                            </ul>
                        </nav>
                    </div>
                </div><br/>     
                
                <div class="card">
                    <div class="card-header">
                        <div class="header-buttons">
                            <a class='button is-primary' v-on:click="showOptionsQR()" v-show="!optionsQR">
                                QR Tags
                            </a>
                            <a class="button is-primary" v-on:click="closeShowOptionsQR()" v-show="optionsQR">QR Tags [X]</a>
                            <a class="button is-info" v-on:click="goManageStudents()">Manage Students</a>
                        </div>
                    </div>
                    
                    <div class="card-content" v-show="optionsQR">
                        <div class="card-content">
                            <b-select id="qrType" name="qrType" v-model="qr_type">
                                <option selected value="-1">Select QR Type to print</option>
                                <option value="0">Full QR Tags</option>
                                <option value="4">One QR Tag per page (directly printable)</option>
                                <option value="1">QR Only(2.5cm)</option>
                                <option value="2">QR Only(3.5cm)</option>
                                <option value="3">Excel</option>
                            </b-select>
                            <br/>
                            <div v-show="qr_type==4">
                                <div class="myLabel">Also include</div>
                                <div class="myInput">
                                    <input type="checkbox" id="1" value="1" v-model="qr_dataToPrint"><label for="1">Group Name</label>&nbsp;&nbsp;
                                    <input type="checkbox" id="2" value="2" v-model="qr_dataToPrint"><label for="2">Tick this ONLY if the school logo is wide</label>&nbsp;&nbsp;
                                </div>
                                
                                <div class="myLabel">Background image:</div>                                
                                <v-select :options="listQrBg" label="title" class="badgeDropdown" key="fileName" v-model="qr_bg">
                                    <template slot="option" slot-scope="option">
                                        <img :src="option.thumb" class="badgeImage" />
                                        <div class="badgeTitle">{{ option.title }}</div>
                                    </template>
                                </v-select>

                            </div>
                            <br/>
                            <a class='button is-primary' v-on:click="printQR()">Print QR</a>
                        </div>
                    </div>
                </div><br/>           

                <div class="columns">                
                    <div class="column is-full">
                        <div class="card">
                            <loading :active.sync="isLoading1" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Today's Points:</p>
                                <span class="header-tag">{{ dailyPoints }} points</span>
                                <div style="padding: 15px; padding-left: 0px;">
                                    <a class="button is-info is-small" style="margin-left: 5px;" v-on:click="downloadAsExcel('positive','daily')">Download As Excel</a>
                                </div>
                            </div>
                            <div class="card-content">
                                <daily-points 
                                :groupID="groupID"
                                :dailyPointsID="dailyPointsID" 
                                :dailyPointsLabel="dailyPointsLabel" 
                                :dailyPointsColor="dailyPointsColor" 
                                :dailyPointsData="dailyPointsData" 
                                v-if="isDailyPointsAvailable" :width="800"></daily-points>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-full">
                        <div class="card">
                            <loading :active.sync="isLoading2" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Overall Points for {{ actionYear }}: </p>
                                <span class="header-tag">{{ overallPoints }} points</span>
                                <div style="padding: 15px; padding-left: 0px;">
                                    <a class="button is-info is-small" style="margin-left: 5px;" v-on:click="downloadAsExcel('positive','overall')">Download As Excel</a>
                                </div>
                            </div>
                            <div class="card-content">
                                <overall-points 
                                :groupID="groupID"
                                :overallPointsID="overallPointsID" 
                                :overallPointsLabel="overallPointsLabel" 
                                :overallPointsColor="overallPointsColor" 
                                :overallPointsData="overallPointsData" v-if="isOverallPointsAvailable" :width="800"></overall-points>
                                <span v-if="!isOverallPointsAvailable" class="inline-error-message">{{ overallPointsErrorMessage }}</span>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>

                <div class="columns is-multiline">

                    <div class="column is-full">
                        <div class="card">
                            <loading :active.sync="isLoading3" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Today's Attendance  ({{ attendanceCount }}/{{ studentCount}})</p>
                            </div>
                            <div class="card-content attendance-pie">
                                <attendance-daily-with-late :height="200" 
                                :attendanceOnTimeCount="attendanceOnTimeCount"
                                :attendanceLateCount="attendanceLateCount"
                                :absentCount="absentCount" 
                                :groupID="groupID"
                                :groupName="groupName"
                                v-if="isAttendanceDataAvailable"></attendance-daily-with-late>
                            </div>
                        </div>
                        <br />
                    </div>

                    <!-- <div class="column is-half">
                        <div class="card">
                            <div class="card-header">
                                <p class="card-header-title">Attendance Data</p>
                            </div>
                            <div class="card-content">
                                <a class="button is-info" v-on:click="downloadAsExcel('attendance','overall')">Download attendance in excel</a>
                            </div>
                        </div>
                        <br />
                    </div> -->
                    
                    <div class="column is-half">
                        <div class="card">
                            <loading :active.sync="isLoading4" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Top students for this month</p>
                            </div>
                            <div class="card-content">
                                <div class="columns">                                    
                                    <div class="column is-three-quarters">Name</div>
                                    <div class="column text-center">Points</div>
                                </div>
                                <div class="columns top-border" v-for="leaders in sortData(monthlyLeaderboard)" :key="leaders._id" v-show="monthlyLeaderboard.length > 0">
                                    <div class="column is-three-quarters">{{ leaders.firstName }} {{ leaders.lastName }}</div>
                                    <div class="column text-center">{{ leaders.tempNumber1 }}</div>
                                </div>
                                <span v-show="monthlyLeaderboard.length == 0" class="inline-error-message">{{ monthlyLeaderboardErrorMessage }}</span>
                            </div>
                        </div>
                        <br />
                    </div>
                    
                    <div class="column is-half">
                        <div class="card">
                            <loading :active.sync="isLoading5" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">All-time Top students </p>
                            </div>
                            <div class="card-content">
                                <div class="columns">                                    
                                    <div class="column is-three-quarters">Name</div>
                                    <div class="column text-center">Points</div>
                                </div>
                                <div class="columns top-border" v-for="leaders in sortData(overallLeaderboard)" :key="leaders._id" v-show="overallLeaderboard.length > 0">
                                    <div class="column is-three-quarters">{{ leaders.firstName }} {{ leaders.lastName }}</div>
                                    <div class="column text-center">{{ leaders.tempNumber1 }}</div>
                                </div>
                                <span v-show="overallLeaderboard.length == 0" class="inline-error-message">{{ overallLeaderboardErrorMessage }}</span>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                

            </div>
        </div>

    </section>    
</div>
</template>

<script>
import TopMenu from '../TopMenu'
import axios from 'axios'
import "../public/style.scss";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToastProgrammatic as Toast } from 'buefy'


import OverallPoints from './Charts/OverallPoints'
import DailyPoints from './Charts/DailyPoints'
import AttendanceDailyWithLate from './Charts/AttendanceDailyWithLate'

export default {
    name: "GroupDashboardSingle",
    components: {
        TopMenu,
        OverallPoints,
        DailyPoints,
        AttendanceDailyWithLate,
        Loading
    },
    data() {
        return {
            groupID: '',
            groupName: '',

            actionYear: '',
            actionMonth: '',
            actionDate: '',

            isOverallPointsAvailable: false,
            overallPoints: 0,
            overallPointsID: [],
            overallPointsLabel: [],
            overallPointsColor: [],
            overallPointsData: [],
            overallPointsErrorMessage: '',

            isDailyPointsAvailable: false,
            dailyPoints: 0,
            dailyPointsID: [],
            dailyPointsLabel: [],
            dailyPointsColor: [],
            dailyPointsData: [],

            isAttendanceDataAvailable: false,
            studentCount: 0,
            attendanceCount: 0,
            attendanceOnTimeCount: 0,
            attendanceLateCount: 0,
            absentCount: 0,

            monthlyLeaderboard: [],
            overallLeaderboard: [],
            monthlyLeaderboardErrorMessage: '',
            overallLeaderboardErrorMessage: '',

            isLatestActivitiesAvailable: false,
            latestActivities: [],

            isLoading1: false,
            isLoading2: false,
            isLoading3: false,
            isLoading4: false,
            isLoading5: false,

            optionsQR: false,
            qr_type: -1,
            qr_dataToPrint: [],
            qr_bg: {
                id: 1,
                title: "Background 1",
                fileName: "01.jpg",
                thumb: "http://admin.studentqr.com/qr_bg/01.jpg"
            },
            showPreview: false,
            imagePreview: '',
            listQrBg: []
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    computed:{     
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.actionMonth = currentMonth;
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = currentDate.getFullYear() + "" + currentMonth + "" + currentDay;
        this.actionYear = currentDate.getFullYear()

        this.groupID = this.$store.getters.getViewGroupID;

        if (this.groupID.trim.length < 1){
            this.groupID = localStorage.getItem('VIEW_GROUP_ID')
        }

        this.groupName = this.$store.getters.getViewGroupName;

        if (this.groupName.trim.length < 1){
            this.groupName = localStorage.getItem('VIEW_GROUP_NAME')
        }
        this.getBackgroundQRImages()

        // this.groupID = this.$store.getters.getGroupDashboardSingleID;

        // if (this.groupID.trim.length < 1){
        //     this.groupID = localStorage.getItem('GROUP_DASHBOARD_SINGLE_ID')
        // }

        // this.groupName = this.$store.getters.getGroupDashboardSingleName;

        // if (this.groupName.trim.length < 1){
        //     this.groupName = localStorage.getItem('GROUP_DASHBOARD_SINGLE_NAME')
        // }
    },
    mounted(){
        
        this.$root.$emit('activeSideMenu',"GroupDashboardSingle") 

        this.getDailyPoints()
        this.getOverallPoints()
        this.getTodayAttendance()
        this.getMonthlyLeaderboard()
        this.getOverallLeaderboard()
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        sortData(arrays){
            return _.orderBy(arrays, 'tempNumber1', 'desc');  //we're using the magical lodash function here
        },
        isShowRightBorder(index){
            if (index % 2 == 0){
                return 'right-border'
            }
        },        
        downloadAsExcel(what,period){

            let self = this;
            console.log("downloadAsExcel with: " + what + " and period: " + period)

            if (what == "positive"){
                
                var displayDate = "";
                var what = "";
                var duration = "";
                if (period == 'daily'){
                    displayDate = self.todayDateDisplay;
                    what = 'group_positives_daily';
                    duration = self.actionDate;
                }else{
                    displayDate = self.displayMonth + " " + self.actionYear
                    what = 'group_positives_overall';
                    duration = self.actionYear
                }

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'blob'
                axios.post(process.env.MY_URL + '/api/group/excel', {
                        params: {
                            email: localStorage.getItem('email'),
                            sessionID: localStorage.getItem('sessionID'),
                            what: what,
                            groupID: self.groupID,
                            groupName: self.groupName,
                            duration: duration,
                            displayDate: displayDate,
                        }
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', duration + "_group_positive_behavior.xlsx"); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        self.isLoading1 = false;
                    })
                    .catch(e => {
                        console.log("181 Error:" + e)
                    }) 
                    

            }else{
                alert("Not available.")
            }
        },
        getDailyPoints(){
            let self = this;
            self.isLoading1 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/group/positive/total', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        groupID: self.groupID,
                        show: 'daily',
                        actionDate: self.actionDate
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.

                    for (var i = 0; i < response.data.length; i++){
                        self.dailyPointsID.push(response.data[i]._id)
                        self.dailyPointsLabel.push(response.data[i].name)
                        self.dailyPointsColor.push(response.data[i].colour)
                        self.dailyPointsData.push(response.data[i].tempTotalPoints)
                        self.dailyPoints = self.dailyPoints + response.data[i].tempTotalPoints;
                    }

                    self.isDailyPointsAvailable = true
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false;
                })     
        },
        getOverallPoints(){
            let self = this;
            self.isLoading2 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/group/positive/total', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        groupID: self.groupID,
                        show: 'overall',
                        actionYear: self.actionYear
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    if (response.data.success == false){
                        self.isOverallPointsAvailable = false
                        self.overallPointsErrorMessage = response.data.msg

                    }else{

                        for (var i = 0; i < response.data.length; i++){
                            self.overallPointsID.push(response.data[i]._id)
                            self.overallPointsLabel.push(response.data[i].name)
                            self.overallPointsColor.push(response.data[i].colour)
                            self.overallPointsData.push(response.data[i].tempTotalPoints)
                            self.overallPoints = self.overallPoints + response.data[i].tempTotalPoints;
                        }
                        self.isOverallPointsAvailable = true
                    }

                    self.isLoading2 = false;
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading2 = false;
                })     
        },
        getTodayAttendance(){
            let self = this;
            self.isLoading3 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/group/attendance/summary', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        groupID: self.groupID,
                        show: 'today',
                        actionDate: self.actionDate
                    }
                })
                .then(response => {

                    if (response.data.success){
                        self.studentCount = response.data.studentCount
                        self.attendanceCount = response.data.attendanceCount
                        self.attendanceOnTimeCount = response.data.onTimeCount
                        self.attendanceLateCount = response.data.lateCount
                        self.absentCount = response.data.absentCount
                        self.isAttendanceDataAvailable = true;
                    }else{
                        self.studentCount = 0;
                        self.attendanceCount = 0;
                        self.attendanceOnTimeCount = 0;
                        self.attendanceLateCount = 0;
                        self.absentCount = 0;
                    }
                    self.isLoading3 = false;
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading3 = false;
                })     
        },
        getMonthlyLeaderboard(){
            let self = this;
            self.isLoading4 = true;
            console.log("getMonthlyLeaderboard")
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/group/leaderboard', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        duration: 'monthly',
                        show: 'students',
                        groupID: self.groupID,
                        actionYear: self.actionYear,
                        actionMonth: self.actionMonth
                    }
                })
                .then(response => {
                    
                    if (response.data.success == false){
                        self.monthlyLeaderboard = []
                        self.monthlyLeaderboardErrorMessage = response.data.msg
                    }else{
                        self.monthlyLeaderboard = response.data.content
                    }
                    self.isLoading4 = false;
                })
                .catch(e => {
                    console.log("344 Error:" + e)
                    self.isLoading4 = false;
                }) 

        },
        showOptionsQR(){
            this.optionsQR = true;
        },
        closeShowOptionsQR(){
            this.optionsQR = false;
        },
        getBackgroundQRImages(){
            console.log("entering getBackgroundQRImages")
            let self = this;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/public/qr_bg/list', {
                })
                .then(response => {
                    // JSON responses are automatically parsed
                    self.listQrBg = response.data
                    for (var i = 0; i < self.listQrBg.length; i++){
                        self.listQrBg[i].thumb = "http://admin.studentqr.com/qr_bg/" + self.listQrBg[i].fileName
                    }
                    console.log("911 self.listQrBg")
                    console.log(self.listQrBg)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        printQR(){
            console.log("entering printQR with qr_type")
            console.log(this.qr_type)
            if (this.qr_type == -1){
                Toast.open({
                    message: "Please select the QR type you want to print",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
            }else{
                this.downloadQRTags(this.qr_type)
            }
        },
        downloadQRTags(printType){
            let self = this;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/api/students/qr_multiple', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        what: "group",
                        groupID: self.groupID,
                        groupName: self.groupName,
                        printType: printType,
                        printData: self.qr_dataToPrint,
                        background: self.qr_bg
                    }
                })
                .then(response => { 
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    if (printType == 3){
                        link.setAttribute('download', 'tags_students.xlsx'); //or any other extension
                    }else{
                        link.setAttribute('download', 'tags_students.pdf'); //or any other extension
                    }
                    document.body.appendChild(link);
                    link.click();

                    // let blob = new Blob([response.data], { type: 'application/pdf' }),
                    // url = window.URL.createObjectURL(blob)

                    //     window.open(url) 

                    // this.dataList = response.data
                    // console.log(this.dataList)
                })
                .catch(e => {
                    console.log(e)
                    alert("Error generating QR code. Please make sure your school logo is a valid image.")
                })
        },
        getOverallLeaderboard(){
            let self = this;
            self.isLoading5 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/group/leaderboard', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        duration: 'yearly',
                        show: 'students',
                        groupID: self.groupID,
                        actionYear: self.actionYear
                    }
                })
                .then(response => {
                    if (response.data.success == false){
                        self.overallLeaderboard = []
                        self.overallLeaderboardErrorMessage = response.data.msg
                    }else{
                        self.overallLeaderboard = response.data.content
                    }
                    self.isLoading5 = false;

                })
                .catch(e => {
                    console.log("344 Error:" + e)
                    self.isLoading5 = false;
                }) 

        },
        goManageStudents(){            
            this.$store.commit('UPDATE_VIEW_GROUP_ID',this.groupID)
            this.$store.commit('UPDATE_VIEW_GROUP_NAME',this.groupName)
            localStorage.setItem('VIEW_GROUP_ID',this.groupID)
            localStorage.setItem('VIEW_GROUP_NAME',this.groupName)
            this.$router.push({
                name: "DbGroupManageStudents"
            });
        },
        goGroupDashboard(){
            this.$router.push({
                name: "GroupDashboard"
            });
        },
    }
};
</script>

<style scoped>
.badgeDropdown{
    width: 300px;
}
.badgeImage{
    width: 50px;
}
.badgeTitle{
    padding-top: 30px !important;
    float: right;
}
.attendance-pie{
    width: 250px;
    height: 250px;
}
.header-buttons{
    margin: 2px;
    padding: 2px;
    float: left;
}
.header-tag{
    margin-left: 10px;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.top-border{
    border-top: 1px solid #CCC
}
.right-border{
    border-right: 1px solid #CCC
}
.text-center{
    text-align: center;
}
.breadcrumb{
    padding: 10px;
    width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Group/DashboardSingle.vue